import $ from 'jquery';
import $script from 'scriptjs';

export default class TemplateAccountAddresses {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);
    this.countryProvinceSelectors = [];
    this.toggleForm = $('[data-toggle-address-form]', this.$el);
    this.toggleEdit = $('[data-edit-address]', this.$el);
    this.deleteAddress = $('[data-delete-address]', this.$el);

    this.countryProvinceSelector = new Shopify.CountryProvinceSelector(
      'address-country',
      'address-province',
      {
        hideElement: 'address-province-container',
      },
    );

    this._bindEvents();

    const $addresses = $('[id^=address-country-]', this.el);
    $addresses.each((index, address) => {
      const $address = $(address);
      const addressId = $address.attr('id').split('-')[2];

      this.countryProvinceSelectors.push(new Shopify.CountryProvinceSelector(
        `address-country-${addressId}`,
        `address-province-${addressId}`,
        {
          hideElement: `address-province-container-${addressId}`,
        },
      ));
    });
  }

  _bindEvents() {
    this.toggleEdit.each((i, el) => {
      $(el).on('click', (e) => {
        e.preventDefault();
        const addressID = $(el).data('edit-address');
        Shopify.CustomerAddress.toggleForm(addressID);
      });
    });

    this.deleteAddress.each((i, el) => {
      $(el).on('click', (e) => {
        e.preventDefault();
        const addressID = $(el).data('delete-address');
        Shopify.CustomerAddress.destroy(addressID, 'Are you sure you wish to delete this address?');
      });
    });

    this.toggleForm.on('click', (e) => {
      e.preventDefault();
      Shopify.CustomerAddress.toggleNewForm();
    })
  }

  onSectionUnload(){
    this._unbindEvents();
  }

  _unbindEvents() {
    this.toggleEdit.each((i, el) => {
      $(el).off('click');
    });


    this.deleteAddress.each((i, el) => {
      $(el).off('click');
    });

    this.toggleForm.off('click');
  }
}
